import ZMC from "components/Stacker/constants/ZoomModalConstants"

export const updateSlide = (index) => {
  return {
    type: ZMC.ZOOM_MODAL_UPDATE_SLIDE,
    payload: index,
  }
}

export const destroyZoomModal = () => {
  return {
    type: ZMC.ZOOM_MODAL_DESTROY,
  }
}

export const zoomIn = (newScale) => {
  return {
    type: ZMC.ZOOM_MODAL_ZOOM_IN,
    payload: newScale,
  }
}

export const zoomOut = (newScale) => {
  return {
    type: ZMC.ZOOM_MODAL_ZOOM_OUT,
    payload: newScale,
  }
}
